import Vuex from 'vuex';
import { initialSubscriptionState, subscriptionModule } from './modules/subscription'
import { initialSubscriptioPreferencenState, subscriptionPreferenceModule } from './modules/subscription-preference'

export const initialState = () => ({
  subscription: initialSubscriptionState(),
  subscriptionPreference: initialSubscriptioPreferencenState(),
});

const createStore = () =>
  new Vuex.Store({
    modules: {
      subscription: subscriptionModule,
      subscriptionPreference: subscriptionPreferenceModule,
    },
  });

export default createStore;
